import { render, staticRenderFns } from "./EmployeeWorkflowRejectedStage.vue?vue&type=template&id=2a771cf1&scoped=true&"
import script from "./EmployeeWorkflowRejectedStage.vue?vue&type=script&lang=ts&"
export * from "./EmployeeWorkflowRejectedStage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a771cf1",
  null
  
)

export default component.exports